import React from 'react';
import cls from 'classnames';
import styles from './agreement_list.module.scss';

type Props = {
  visible?: boolean;
}

/**
 * Renders a confirmation before performing a sensitive action on an agreement.
 */
export const AgreementActionConfirmation: React.FC<Props> = ({ visible, children }) => (
  <div className={cls([styles.confirmation, visible ? styles.visible : null])}>
    {children}
  </div>
);